// extracted by mini-css-extract-plugin
export default {"pageGroupWrapper":"JsJXaX","pageGroup":"AnQkDU"};